export const ErrorMessage = ({error}: { error: string }) => {
  if (!error) return null;

  return (
    <p className="input-error">
      {error}
      </p>
  );
};